<template>
  <div id="userActivateWrapper">
    <div class="columns is-centered">
      <div class="column is-half">
        <article class="message" :class="auth ? 'is-success' : 'is-danger'">
          <div class="message-header">
            <p v-if="auth">Account geactiveerd</p>
            <p v-else>Activatie mislukt</p>
          </div>

          <div v-if="auth" class="message-body content">
            <p>Uw account is succesvol geactiveerd.<br>De link in de e-mail is nu ongeldig, gebruik in het vervolg <strong>https://ct.learningmatters.nl</strong> om de applicatie te openen.</p>
            <p>U wordt nu automatisch doorgeleid naar de applicatie.<br>Wordt u niet binnen 5 seconden dooverwezen naar de applicatie, <router-link :to="{ name: 'list-bundles' }">klik dan hier</router-link>.</p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      auth: 'account/auth'
    })
  },
  created () {
    this.$store.dispatch('account/activate', this.$route.params.activationCode)
  },
  watch: {
    auth () {
      if (this.auth) {
        setTimeout(() => this.$router.push({ name: 'list-bundles' }), 5000)
      }
    }
  }
}
</script>
